module.exports = __webpack_public_path__ + "static/media/website.0a332294.png";